import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';

export default function RequestSummaryCard({ summary }) {
  if (!summary) return null;

  return (
    <Card className="bg-gray-50">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Request Summary</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2 text-sm">
        {summary.variant && (
          <div className="flex justify-between items-center gap-2">
            <span className="text-gray-600">Variant</span>
            <Badge variant={summary.isMosipVariant ? 'face' : 'outline'}>{summary.variant}</Badge>
          </div>
        )}
        {summary.mosipVariantYesNo != null && (
          <div className="flex justify-between">
            <span className="text-gray-600">MOSIP variant</span>
            <span className="font-medium">{summary.mosipVariantYesNo ? 'Yes' : 'No'}</span>
          </div>
        )}
        {summary.endpoint && (
          <div className="flex justify-between gap-2">
            <span className="text-gray-600 shrink-0">Endpoint</span>
            <span className="font-medium text-xs text-right break-all">{summary.endpoint}</span>
          </div>
        )}
        {summary.inputType && (
          <div className="flex justify-between">
            <span className="text-gray-600">Input type</span>
            <span className="font-medium">{summary.inputType}</span>
          </div>
        )}
        {summary.operation && (
          <div className="flex justify-between">
            <span className="text-gray-600">Operation</span>
            <span className="font-medium">{summary.operation}</span>
          </div>
        )}
        {summary.inputs && (
          <div className="flex justify-between gap-2">
            <span className="text-gray-600 shrink-0">Input(s)</span>
            <span className="font-medium text-right break-all">{summary.inputs}</span>
          </div>
        )}
        {summary.extra && Object.entries(summary.extra).map(([key, value]) => (
          <div key={key} className="flex justify-between">
            <span className="text-gray-600">{key}</span>
            <span className="font-medium">{String(value)}</span>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
